import { render, staticRenderFns } from "./orderDIFOTOutboundTaskPerformanceWidget.vue?vue&type=template&id=4e0f2fe0&"
import script from "./orderDIFOTOutboundTaskPerformanceWidget.vue?vue&type=script&lang=js&"
export * from "./orderDIFOTOutboundTaskPerformanceWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports